var ADDON_ID="addon-controls",PARAM_KEY="controls";

export { ADDON_ID, PARAM_KEY };
